//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
import CbDiamond from '../diamond';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "reward-item"
  }, [_c('div', {
    staticClass: "reward-item__content"
  }, [_vm.reward.tag ? _c('div', {
    staticClass: "reward-item__content-tag"
  }, [_c('img', {
    attrs: {
      "src": _vm.reward.tag
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reward-item__content-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.reward.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reward-item__content-title"
  }, [_vm._t("title", function () {
    return [_vm._v(_vm._s(_vm.reward.name))];
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "reward-item__content-value"
  }, [_vm._t("value", function () {
    return [_c('CbDiamond', [_vm._v(_vm._s(_vm.reward.coins))])];
  })], 2), _vm._v(" "), _vm._t("default")], 2)]);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-23d9a75f',
  render,
  name: 'CbRewardItem',
  props,
  components: {
    CbDiamond
  }
});